import Link from '@/components/UI/Link';
import { typeToTextMap } from '@/referenceData/study/type';
import { web as webRoutes } from '@/support/route';
import { DateTimeRenderer } from '@/components/UI/DateRenderers/DateRenderers';
import { type TanStackColumnDef } from '@/components/UI/Table/TableComponent.model';

interface FormData {
  id: string;
  name: string;
  type: string;
  created_at: string;
}

export const tableColumns: Array<TanStackColumnDef<FormData>> = [
  {
    id: 'name',
    header: 'Name',
    accessorKey: 'name',
    enableSorting: true,
    cell: ({ row: { original } }: { row: { original: FormData } }) => (
      <Link className="blue" to={webRoutes('team.studies.forms.edit', { id: original.id })}>
        {original.name}
      </Link>
    ),
  },
  {
    id: 'type',
    header: 'Type',
    accessorKey: 'type',
    enableSorting: true,
    cell: ({ row: { original } }: { row: { original: FormData } }) => {
      return <>{typeToTextMap[original?.type]}</>;
    },
  },
  {
    id: 'created_at',
    header: 'Created',
    accessorKey: 'created_at',
    enableSorting: true,
    cell: ({ row: { original } }: { row: { original: FormData } }) => <DateTimeRenderer value={original.created_at} />,
  },
];

export const getParams = (
  query = '',
  sort = ['id'],
  order = 'desc',
  paging = {
    total_pages: 1,
    current_page: 1,
    per_page: 10,
  }
) => {
  let url = '';
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (query) {
    url = `${url}&search=${query}`;
  }
  url = `${url}&order=${order}&sort=${sort}&page=${paging.current_page}&perPage=${paging.per_page}`;

  return url;
};
